import axios, { AxiosError } from 'axios';
import { ChatResponse, SessionsList, SessionHistory } from '@/types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '<INTERNAL_HOST_REMOVED>';

interface ApiRequestConfig {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  url: string;
  data?: any;
}

async function apiRequest<T>(config: ApiRequestConfig): Promise<T> {
  try {
    const response = await axios({
      method: config.method,
      url: `${API_BASE_URL}${config.url}`,
      data: config.data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        throw new Error('API request failed');
      } else if (axiosError.request) {
        throw new Error('Network error');
      }
    }
    throw new Error('API request failed');
  }
}

export const api = {
  async chat(sessionId: string, message: string): Promise<string> {
    const data = await apiRequest<ChatResponse>({
      method: 'POST',
      url: '/api/chat',
      data: { sessionId, message },
    });
    return data.response;
  },

  async getSessions(): Promise<string[]> {
    const data = await apiRequest<SessionsList>({
      method: 'GET',
      url: '/api/sessions',
    });
    return data.sessions;
  },

  async deleteSession(sessionId: string): Promise<void> {
    await apiRequest<{ success: boolean }>({
      method: 'DELETE',
      url: `/api/sessions/${sessionId}`,
    });
  },

  async getSessionHistory(sessionId: string): Promise<any[]> {
    const data = await apiRequest<SessionHistory>({
      method: 'GET',
      url: `/api/sessions/${sessionId}/history`,
    });
    return data.history;
  },
};
